import React, { useMemo } from "react";
import { Formik } from "formik";
import { Button } from '@mui/material';
import { bulkUpdateAgentsById } from "../../../services/api-service";
import { showCustomComponentNotification, showErrorNotification } from "../../../components/admin/common/NotiService";
import CustomAutoComplete from "../../../components/admin/common/AutoComplete/CustomAutoComplete";
import { deselectAllRows } from "../../../components/admin/common/OZDataGrid/GridUtil";


export default function AddAgentsToGroup(agentToGroupMenuProps) {

    let buttonStyle = useMemo(
        () => ({
            borderRadius: "0.5rem",
            height: "2.75rem",
            fontSize: "0.875rem",
            fontWeight: 400,
        }),
        []
    );

    async function addAgentToGroup({ agentIds, groupId }) {
        try {
            const resp = await bulkUpdateAgentsById({ action: 'group', ids: agentIds.map(a => a?.id).filter(Boolean).join(','), groups: groupId.toString() })
            if (resp.status === 'IN_PROGRESS') {
                showCustomComponentNotification({
                    component: (
                        <label style={{ fontSize: '14px', fontWeight: '400', color: '#212121' }}>
                            {(resp?.message || 'Update in Progress')} <br />
                            <span style={{ textDecoration: 'none', cursor: 'pointer', color: '#3d8bf8', fontSize: '12px', }}
                                onClick={() => { agentToGroupMenuProps.gotoBulkOperationTranscation() }}
                            >
                                Click here to check the status
                            </span>
                        </label >
                    ),
                    variant: 'success',
                });
                agentToGroupMenuProps.handleClose()
                if (agentToGroupMenuProps?.handleCloseInUpdate) {
                    agentToGroupMenuProps.handleCloseInUpdate()
                }
                deselectAllRows()
            } else if (resp?.message) {
                showErrorNotification(resp?.message)
            }
        } catch (e) {
            console.error(e)
            showErrorNotification("Bulk Operation failed");
        }
    }

    return (
        <div >
            <Formik
                initialValues={agentToGroupMenuProps.initialData}
                onSubmit={(formValues) => {
                    addAgentToGroup({ agentIds: agentToGroupMenuProps.list ?? [], groupId: formValues?.groups?.SeqID })
                }}
            >
                {(formik) => (
                    <div>
                        <form
                            onSubmit={formik.handleSubmit}
                            id="addAgentGroupForm"
                            className="ozcwScrollbar oz-agent-to-group-form"
                        >
                            <CustomAutoComplete
                                name="groups"
                                labelHeader="Group Name"
                                placeholder="Group Name"
                                Datas={agentToGroupMenuProps.autoCompleteList}
                                mode={"Add"}
                                multiple={false}
                                optionLabelName={"GroupName"} />
                        </form>
                    </div>
                )}
            </Formik>
            <div className="oz-agent-to-group-form-buttons" >
                <Button
                    variant="outlined"
                    sx={{ ...buttonStyle, marginRight: '1.25rem' }}
                    onClick={agentToGroupMenuProps.handleClose}>
                    Cancel
                </Button>
                <Button form="addAgentGroupForm" variant="contained" sx={buttonStyle} type="submit">
                    ADD
                </Button>
            </div>
        </div>
    )
}